<template>
  <h1>Placeholder</h1>
</template>

<script>
  export default {
    name: 'Placeholder',
  };
</script>
